var map = {
	"./alertError.vue": "./node_modules/mxs-query-editor/dist/icons/alertError.vue",
	"./alertSuccess.vue": "./node_modules/mxs-query-editor/dist/icons/alertSuccess.vue",
	"./alertWarning.vue": "./node_modules/mxs-query-editor/dist/icons/alertWarning.vue",
	"./arrowDown.vue": "./node_modules/mxs-query-editor/dist/icons/arrowDown.vue",
	"./arrowHead.vue": "./node_modules/mxs-query-editor/dist/icons/arrowHead.vue",
	"./close.vue": "./node_modules/mxs-query-editor/dist/icons/close.vue",
	"./critical.vue": "./node_modules/mxs-query-editor/dist/icons/critical.vue",
	"./criticalServer.vue": "./node_modules/mxs-query-editor/dist/icons/criticalServer.vue",
	"./database.vue": "./node_modules/mxs-query-editor/dist/icons/database.vue",
	"./delete.vue": "./node_modules/mxs-query-editor/dist/icons/delete.vue",
	"./drain.vue": "./node_modules/mxs-query-editor/dist/icons/drain.vue",
	"./edit.vue": "./node_modules/mxs-query-editor/dist/icons/edit.vue",
	"./failover.vue": "./node_modules/mxs-query-editor/dist/icons/failover.vue",
	"./filter.vue": "./node_modules/mxs-query-editor/dist/icons/filter.vue",
	"./good.vue": "./node_modules/mxs-query-editor/dist/icons/good.vue",
	"./goodServer.vue": "./node_modules/mxs-query-editor/dist/icons/goodServer.vue",
	"./gridBg.vue": "./node_modules/mxs-query-editor/dist/icons/gridBg.vue",
	"./logs.vue": "./node_modules/mxs-query-editor/dist/icons/logs.vue",
	"./maintenance.vue": "./node_modules/mxs-query-editor/dist/icons/maintenance.vue",
	"./notFound.vue": "./node_modules/mxs-query-editor/dist/icons/notFound.vue",
	"./paused.vue": "./node_modules/mxs-query-editor/dist/icons/paused.vue",
	"./primaryServer.vue": "./node_modules/mxs-query-editor/dist/icons/primaryServer.vue",
	"./queryEditor.vue": "./node_modules/mxs-query-editor/dist/icons/queryEditor.vue",
	"./reload.vue": "./node_modules/mxs-query-editor/dist/icons/reload.vue",
	"./reports.vue": "./node_modules/mxs-query-editor/dist/icons/reports.vue",
	"./restart.vue": "./node_modules/mxs-query-editor/dist/icons/restart.vue",
	"./running.vue": "./node_modules/mxs-query-editor/dist/icons/running.vue",
	"./search.vue": "./node_modules/mxs-query-editor/dist/icons/search.vue",
	"./secondaryServer.vue": "./node_modules/mxs-query-editor/dist/icons/secondaryServer.vue",
	"./server.vue": "./node_modules/mxs-query-editor/dist/icons/server.vue",
	"./settings.vue": "./node_modules/mxs-query-editor/dist/icons/settings.vue",
	"./start.vue": "./node_modules/mxs-query-editor/dist/icons/start.vue",
	"./statusInfo.vue": "./node_modules/mxs-query-editor/dist/icons/statusInfo.vue",
	"./statusWarning.vue": "./node_modules/mxs-query-editor/dist/icons/statusWarning.vue",
	"./stopped.vue": "./node_modules/mxs-query-editor/dist/icons/stopped.vue",
	"./storedProcedures.vue": "./node_modules/mxs-query-editor/dist/icons/storedProcedures.vue",
	"./switchover.vue": "./node_modules/mxs-query-editor/dist/icons/switchover.vue",
	"./table.vue": "./node_modules/mxs-query-editor/dist/icons/table.vue",
	"./tachometer.vue": "./node_modules/mxs-query-editor/dist/icons/tachometer.vue",
	"./unlink.vue": "./node_modules/mxs-query-editor/dist/icons/unlink.vue",
	"./user.vue": "./node_modules/mxs-query-editor/dist/icons/user.vue",
	"./users.vue": "./node_modules/mxs-query-editor/dist/icons/users.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/mxs-query-editor/dist/icons sync \\.(vue)$/";